import { render } from "./Collected.vue?vue&type=template&id=5ead4854"
import script from "./Collected.vue?vue&type=script&lang=js"
export * from "./Collected.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__